import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import NewsService from '@/services/CmsServices/NewsService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteNewsArticle = createAsyncThunk(
    'news/deleteNewsArticle',
    async (newsArticleId, { rejectWithValue }) => {
        try {
            const response = await NewsService.deleteNewsArticle(newsArticleId);
            return {
                newsArticleId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteNewsArticleSlice = createSlice({
    name: 'deleteNewsArticle',
    initialState: model,
    reducers: {
        resetDeleteNewsArticleStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteNewsArticleStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete news article
        builder.addCase(deleteNewsArticle.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteNewsArticle.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Article deleted successfully!';
        }).addCase(deleteNewsArticle.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteNewsArticleStateOnError,
    resetDeleteNewsArticleStateOnSuccess,
} = deleteNewsArticleSlice.actions;

export default deleteNewsArticleSlice.reducer;
